@if (displayIcon()) {
	<span revTooltip [tooltipContent]="getTooltipText()">
    <i [class]="'fa app-status-icon fa-pencil ' + getColorClass()"></i>
  </span>
}
